import React from 'react';
import {Rankings} from '../../types/rankings';
import {
  styled,
  TextTag,
  Text,
  TokenTextAppearance,
  CTA,
} from '@volkswagen-onehub/components-core';
import useTrans from '../../hooks/use-trans';
import {useFeatureServices} from '../../use-feature-services';
import {Stat} from '../../types/stats';
import {ContainerMain} from '../../styles/global.style';

interface ResultRecommendationInterface {
  rankings: Rankings;
}

const ResultRecommendationContainer = styled.div`
  margin-top: ${(props) => props.theme.size.grid002};
  margin-bottom: ${(props) => props.theme.size.grid001};
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.size.dynamic0130};
  align-items: center;
`;

const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.size.dynamic0250};

  a {
    font-size: 1.3rem;
  }

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.size.dynamic0040};

  img {
    width: 100%;
  }

  a {
    font-weight: bold;
  }
`;

const ResultRecommendation: React.FC<ResultRecommendationInterface> = ({
  rankings,
}) => {
  const {tracking} = useFeatureServices();
  const trans = useTrans();

  const handleLearnClick = (
    e: React.SyntheticEvent<HTMLAnchorElement>,
    stat: Stat,
  ) => {
    e.preventDefault();

    tracking.track('VWBasic_Link_Click', {
      configuration: {
        CarlineName: stat.result?.carlineName,
      },
      link: {
        url: stat.result?.cta.learn.url,
        name: stat.result?.cta.learn.linkName,
      },
    });

    window.open(stat.result?.cta.learn.url, '_self');
  };

  return (
    <ContainerMain>
      <ResultRecommendationContainer>
        <Text
          tag={TextTag.h3}
          appearance={TokenTextAppearance.headline400}
          bold
        >
          {trans.pages.results.suggestion}
        </Text>
        <CardsContainer>
          {rankings.slice(1, 4).map(([key, stat]) => (
            <CardContainer key={key}>
              <img
                src={stat.result?.imageRecommended.url}
                alt={stat.result?.imageRecommended.alt}
              />

              <CTA
                tag="a"
                emphasis="tertiary"
                href={stat.result?.cta.learn.url}
                onClick={(e) => {
                  handleLearnClick(e, stat);
                }}
              >
                {stat.model.modelName}
              </CTA>
            </CardContainer>
          ))}
        </CardsContainer>
      </ResultRecommendationContainer>
    </ContainerMain>
  );
};

export default ResultRecommendation;
